<template>
    <li
        v-if="isViewAll || isMobile"
        class="relative grid w-full min-h-[92px] items-center gap-x-4 font-oceanside text-black"
        :class="{
            'grid-cols-[minmax(0,112px)_minmax(0,1fr)]': !isViewAll,
            'grid-cols-[minmax(0,112px)_minmax(0,1fr)_12px]': isViewAll,
        }"
    >
        <arrow-icon
            v-if="isMobile && !isViewAll"
            class="absolute left-[-20px] top-1/2 h-[16px] w-[9px] -translate-y-1/2 rotate-180"
            :class="{ 'text-gray-DFDFDF': isFirstSlide }"
            @click.stop="goToPreviousSlide"
        />

        <div
            :class="[
                'min-w-0',
                isViewAll
                    ? 'grid grid-cols-[20px_minmax(0,1fr)] items-center gap-x-2'
                    : 'relative h-[92px] self-start',
            ]"
        >
            <div
                :class="[
                    'grid grid-cols-[20px_minmax(0,1fr)] items-center gap-x-2',
                    !isViewAll && 'absolute left-0 top-1/2 w-full -translate-y-1/2',
                ]"
            >
                <div class="relative h-5 w-5">
                    <transition name="cz3__fade">
                        <img
                            v-if="showCheckFilled"
                            src="../assets/images/icons/check-filled.svg"
                            width="20"
                            height="20"
                            alt="Check filled"
                            class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                        >
                        <img
                            v-else-if="hasErrors"
                            src="../assets/images/icons/check-red.svg"
                            width="20"
                            height="20"
                            alt="Check red"
                            class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                        >
                        <img
                            v-else
                            src="../assets/images/icons/check-grey.svg"
                            width="20"
                            height="20"
                            alt="Check unselected"
                            class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                        >
                    </transition>
                </div>

                <div
                    :class="{
                        'text-red-error': hasErrors,
                    }"
                    class="relative min-w-0 text-[16px] font-semibold capitalize whitespace-nowrap"
                >
                    {{ itemData.name }}
                    <div
                        v-if="hasErrors"
                        class="absolute whitespace-nowrap -mt-[7px] text-[14px] font-normal text-red-error flex items-center gap-x-[4px]"
                    >
                        {{ $t('PLEASE_MAKE_SELECTIONS') }}
                        <img
                            src="../assets/images/icons/exclamation-red.svg"
                            width="12"
                            height="12"
                            alt="Exclamation mark"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="grid min-w-0 justify-items-end text-right">
            <current-selection
                :placement-data="itemData"
                :justify-text-end="true"
                :class="[
                    'max-w-[80%]',
                    hasErrors && 'text-red-error max-w-[60%]',
                ]"
                :has-errors="hasErrors"
            />
            <div
                v-if="isLocked && !isSurefitHubLocked"
                class="mt-[2px] grid w-full max-w-[190px] items-start gap-x-2 text-[12px] leading-4 text-gray-dark"
            >
                <div class="text-right">
                    <div v-if="itemData.code === 'Headcover'">
                        <crown-icon
                            class="mr-[2px] w-[24px] text-gray-dark inline-block"
                        />
                        {{ $t('HEADCOVER_GROUP_LOCKED') }}
                    </div>
                    <div v-else-if="itemData.code === 'Grip'">
                        <crown-icon
                            class="mr-[2px] w-[24px] text-gray-dark inline-block"
                        />
                        {{ $t('GRIP_GROUP_LOCKED') }}
                    </div>
                    <div v-else-if="itemData.code === 'PutterShaftBand'">
                        <crown-icon
                            class="mr-[2px] w-[24px] text-gray-dark inline-block"
                        />
                        {{ $t('SHAFT_BAND_GROUP_LOCKED') }}
                    </div>
                </div>
            </div>
        </div>

        <arrow-icon
            v-if="!isViewAll || !isSurefitHubLocked"
            class="h-[16px] w-[9px]"
            @click.stop="goToNextSlide"
            :class="{
                'text-gray-DFDFDF': isLastSlide,
                'absolute right-[-20px] top-1/2 -translate-y-1/2': !isViewAll,
                'justify-self-end': isViewAll,
            }"
        />
    </li>

    <li
        v-else
        class="w-full flex gap-6 items-center h-[92px]"
    >
        <div class="flex flex-grow gap-2 break-words text-left"
            v-if="!isMobile || isViewAll"
        >
            <div class="relative h-full min-h-[20px] w-5">
                <transition name="cz3__fade">
                    <img
                        v-if="showCheckFilled"
                        src="../assets/images/icons/check-filled.svg"
                        width="20"
                        height="20"
                        alt=""
                        class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                    >
                    <img
                        v-else-if="hasErrors"
                        src="../assets/images/icons/check-red.svg"
                        width="20"
                        height="20"
                        alt=""
                        class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                    >
                    <img
                        v-else
                        src="../assets/images/icons/check-grey.svg"
                        width="20"
                        height="20"
                        alt=""
                        class="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2"
                    >
                </transition>
            </div>

            <div
                :class="{
                    'text-red-error': hasErrors,
                }"
                class="text-[16px] font-semibold capitalize whitespace-nowrap"
            >
                {{ itemData.name }}
                <div
                    v-if="hasErrors"
                    class="text-[14px] font-normal text-red-error absolute whitespace-nowrap -mt-[7px]"
                >
                    {{ $t('PLEASE_MAKE_SELECTIONS') }}
                </div>
            </div>
        </div>

        <div class="lg:flex-1" />

        <div class="flex flex-col lg:mx-0 -mx-[32px]">
            <current-selection
                :placement-data="itemData"
                class="w-full"
            />
            <div
                class="text-[12px] text-gray-dark lg:text-right w-64 leading-4 flex gap-2 items-center"
                v-if="isLocked"
            >
                <crown-icon
                    class="text-gray-dark w-[64px]"
                />
                <template v-if="itemData.code === 'Headcover'">
                    {{ $t('HEADCOVER_GROUP_LOCKED') }}
                </template>
                <template v-else-if="itemData.code === 'Grip'">
                    {{ $t('GRIP_GROUP_LOCKED') }}
                </template>
                <template v-else-if="itemData.code === 'PutterShaftBand'">
                    {{ $t('SHAFT_BAND_GROUP_LOCKED') }}
                </template>
            </div>
        </div>
    </li>
</template>

<script>
    import allStores from '../stores/all';
    import CrownIcon from './CrownIcon.vue';
    import CurrentSelection from './CurrentSelection.vue';
    import ArrowIcon from './ArrowIcon.vue';

    export default {
        mixins: [allStores],

        components: {
            CurrentSelection,
            CrownIcon,
            ArrowIcon,
        },

        emits: ['selectionMade', 'goToPreviousSlide', 'goToNextSlide'],

        props: {
            itemData: {
                type: Object,
                required: true,
            },

            isViewAll: {
                type: Boolean,
                default: false,
            },

            isFirstSlide: {
                type: Boolean,
                default: false,
            },

            isLastSlide: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },

            isLocked() {
                return this.customizerStore.isGroupLocked(this.itemData);
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.itemData.name);
            },

            showCheckFilled() {
                return this.customizerStore.progressGroupHasCheckFilled(this.itemData);
            },

            paintfillGroupName() {
                if (this.itemData?.name === 'Face/Sole' || this.itemData?.code === 'Face/Sole') {
                    return 'Face/Sole';
                }

                if (this.itemData?.name === 'Top' || this.itemData?.code === 'TopPaintfill') {
                    return 'Top';
                }

                if (this.itemData?.name === 'Back' || this.itemData?.code === 'BackPaintfill') {
                    return 'Back';
                }

                return null;
            },

            hasPaintfillErrors() {
                return !!this.paintfillGroupName
                    && this.customizerStore.isAnyPaintfillSelected()
                    && !this.customizerStore.isPaintfillComplete(this.paintfillGroupName);
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            isCurrentGroup() {
                return this.itemData.name === this.currentGroup;
            },

            inErrorState() {
                return false;
            },

            hasErrors() {
                return this.customizerStore.progressGroupHasErrors(this.itemData);
            },

            panelsInErrorState() {
                return this.customizerStore.panelsInErrorState;
            },

            hasBeenSeen() {
                return this.customizerStore.groupsSeen.includes(this.itemData.name);
            },

            placements() {
                if (!this.itemData) {
                    return [];
                }

                const placements = this.itemData.placements;

                return placements ?? [];
            },

            isSurefitHubLocked() {
                return this.customizerStore.isSurefitHubLocked(this.placements);
            },
        },

        watch: {
            selectionWasMade() {
                this.$emit('selectionMade');
            },
        },

        methods: {
            goToPreviousSlide() {
                if (this.isFirstSlide) {
                    return;
                }

                this.$emit('goToPreviousSlide');
            },

            goToNextSlide() {
                if (this.isLastSlide) {
                    return;
                }

                this.$emit('goToNextSlide');
            },
        },
    };
</script>
